var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('core-toolbar'),_c('core-drawer'),_c('core-view'),_c('core-footer'),_c('v-snackbar',{attrs:{"color":_vm.alertColor,"timeout":2000,"top":'top'},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}},[_vm._v(" "+_vm._s(_vm.alertText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }